import ConnectIneligible from '../components/ConnectIneligible';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    app: state.app || {}
  };
};

export default connect(mapStateToProps)(ConnectIneligible);
